import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable, ReplaySubject, Subject } from 'rxjs';
import { NotificationModel } from '../models/NotificationModel';
import { HttpClient } from '@angular/common/http';
import { environment } from '../../environments/environment';

@Injectable({
  providedIn: 'root'
})
export class NotificationService {
   url = environment.apiUrl;

  private notifyRequest = new ReplaySubject<NotificationModel>();
  

  notifyRequest$ = this.notifyRequest.asObservable();

  constructor(private http:HttpClient) {

  }

  notify(notify:NotificationModel ) {
      this.notifyRequest.next(notify);
  }

  getNotifications():Observable<any>{
    return this.http.get(this.url+'notification');
  }




}